import { render, staticRenderFns } from "./RiskAudit.vue?vue&type=template&id=b56552cc&"
import script from "./RiskAudit.vue?vue&type=script&lang=js&"
export * from "./RiskAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports